import Area from '@/components/Area';
import { GizmoHelper, GizmoViewport, OrbitControls } from '@react-three/drei';
import { Canvas } from '@react-three/fiber';
import * as React from 'react';
import * as THREE from 'three';

type WallProps = {
  length: number;
  height?: number;
  thickness?: number;
} & React.ComponentProps<'group'>;

function Wall(props: WallProps) {
  const { length, height = 96, thickness = 4, ...rest } = props;
  return (
    <group {...rest}>
      <line>
        <bufferGeometry>
          <bufferAttribute
            attach="attributes-position"
            array={new Float32Array([0, 0, 0, length, 0, 0])}
            count={2}
            itemSize={3}
          />
        </bufferGeometry>
        <lineBasicMaterial color={0xff0000} />
      </line>
      <mesh
        position={[length / 2, 0, 0]}
        // position={[length / 2, height / 2, 0]}
      >
        <boxGeometry args={[length, thickness, height]} />
        <meshStandardMaterial color={0xaaaaaa} side={THREE.DoubleSide} />
      </mesh>
    </group>
  );
}

function Walls() {
  const [points, setPoints] = React.useState<THREE.Vector3[]>([]);
  const linePoints = React.useMemo(() => {
    const pts: { start: THREE.Vector3; end: THREE.Vector3 }[] = [];
    for (let i = 1; i < points.length; i++) {
      const [start, end] = points.slice(i - 1, i + 1);
      pts.push({ start, end });
    }
    return pts;
  }, [points]);

  const refMoving = React.useRef<THREE.Vector3 | null>(null);
  const bufferGeometry = React.useMemo(() => new THREE.BufferGeometry(), []);

  return (
    <>
      <mesh
        onPointerDown={(e) => {
          const [intersection] = e.intersections;
          if (intersection) {
            const point = intersection.point;
            setPoints((prev) => [...prev, point]);
          }
        }}
        onPointerMove={(e) => {
          refMoving.current = e.point;
          if (points.length) {
            const lastPoint = points[points.length - 1];
            bufferGeometry.setFromPoints([lastPoint, e.point]);
          }
        }}
      >
        <planeGeometry args={[100, 100]} />
        <meshBasicMaterial color={0xcccccc} side={THREE.DoubleSide} />
      </mesh>
      {linePoints.map(({ start, end }, index) => {
        const direction = end.clone().sub(start);
        const length = direction.length();
        const angle = Math.atan2(direction.y, direction.x);
        return <Wall key={index} length={length} position={start} rotation={[0, 0, angle]} />;
      })}
      <line>
        <bufferGeometry attach="geometry" {...bufferGeometry} />
        <lineBasicMaterial color="blue" />
      </line>
    </>
  );
}

export type Props = {};

function App01(props: Props) {
  const {} = props;
  // useFrame(() => {
  //   //
  // });

  return (
    <Area css={{ position: 'relative' }}>
      {(el) => (
        <Canvas
          eventSource={el}
          camera={{
            position: [0, 5, 10],
            fov: 75,
            // lookAt: [0, 0, 0]
          }}
        >
          <ambientLight intensity={0.5} />
          <Walls />
          <OrbitControls />
          <GizmoHelper alignment="bottom-right" margin={[80, 80]}>
            <GizmoViewport axisColors={['red', 'green', 'blue']} labelColor="black" />
          </GizmoHelper>
        </Canvas>
      )}
    </Area>
  );
}

export default React.memo(App01);
